/* eslint-disable */
import Axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import AuthAdmin from "../../../components/AuthAdmin/AuthAdmin";
import Spinner from "../../../components/Spinner/Spinner";
import withErrorHandler from "../../../hoc/withErrorHandler/withErrorHandler";
import * as actions from "../../../store/actions/index";
import CategoriesTable from "./CategoriesTable";
var md5 = require("md5");

class AddCategories extends Component {
  constructor(props) {
    super(props);
    this.state = {
      category: {
        // categoryId: "",
        categoryName: "", 
        // categoryLogoUrl: "",
        // aboutCategory: "",
        // categoryBannerUrl: "",
        // categoryChargeType: "",
      },
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  // componentDidMount() {
  //   this.props.onFetchChargesType();
  // }

  handleChange(e) {
    const { name, value } = e.target;
    let category = { ...this.state.category };
    category[name] = value;
    this.setState({
      category: category,
    });
  }
  // handleUpload = (e) => {
  //   let category = { ...this.state.category };
  //   category[e.target.name] = e.target.files[0];
  //   this.setState({ category: category });
  // };
  // handleChargeType = (e) => {
  //   let chargeId = e.target.value;
  //   let chargeType = this.props.chargeTypes.filter(
  //     (charge) => charge.chargeId == chargeId
  //   )[0];
  //   let category = { ...this.state.category };
  //   category["categoryChargeType"] = chargeType;
  //   this.setState({ category });
  // };
  handleSubmit(e) {
    e.preventDefault();
    let category = this.state.category;
    // if (!category.categoryChargeType) {
    //   return alert("Please Select Charge Type");
    // }
    let timestamp = new Date().getUTCMilliseconds();
    // category.categoryId = md5(timestamp);
    this.setState({
      category: category,
    });
    this.props.onAddCategory(category, this.props.categories);
  }



  render() {
    let category = this.state.category;


    return (
      <div className="container">
        <h3 className="text-center mt-2">Category Management</h3>
        <hr />
        <button
          className="btn btn-primary btn-sm mb-2 p-2"
          style={{
            backgroundColor: "blue",
          }}
          data-toggle="modal"
          data-target=".bd-example-modal-lg"
        >
          Add Category
        </button>
        <div
          className="modal fade bd-example-modal-lg"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLongTitle">
                  Add Category
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <form onSubmit={this.handleSubmit}>
                  <div className="form-row">
                    <div className="form-group col-md-6">
                      <label htmlFor="categoryName">Category Name</label>
                      <input
                        type="text"
                        name="categoryName"
                        className="form-control"
                        id="categoryName"
                        placeholder="Enter Category Name"
                        onChange={this.handleChange}
                        value={category.categoryName}
                        required
                      />
                    </div>
                    {/* <div className="form-group col-md-6">
                      <label htmlFor="categoryLogoUrl">
                        Upload Category Logo
                      </label>
                      <input
                        type="file"
                        name="categoryLogoUrl"
                        className="form-control-file"
                        id="categoryLogoUrl"
                        accept=".png,.jpeg, .jpg, .webp"
                        onChange={this.handleUpload}
                        required
                      />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group col-md-12">
                      <label htmlFor="aboutCategory">About Category</label>
                      <textarea
                        type="text"
                        name="aboutCategory"
                        className="form-control"
                        id="aboutCategory"
                        placeholder="Enter Category Description"
                        rows="3"
                        onChange={this.handleChange}
                        value={category.aboutCategory}
                        required
                      />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group col-md-6">
                      <label htmlFor="categoryBannerUrl">
                        Upload Category Banner
                      </label>
                      <input
                        type="file"
                        name="categoryBannerUrl"
                        className="form-control-file"
                        id="categoryBannerUrl"
                        accept=".png,.jpeg, .jpg, .webp"
                        onChange={this.handleUpload}
                        required
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label
                        className="my-1 mr-2"
                        htmlFor="inlineFormCustomSelectPref"
                      >
                        Additional Charges
                      </label>
                      <select
                        name="categoryChargeType"
                        className="custom-select my-1 mr-sm-2"
                        id="inlineFormCustomSelectPref"
                        onChange={this.handleChargeType}
                        // value={category.categoryChargeType.chargeName?category.categoryChargeType.chargeName:""}
                      >
                        <option value="">Select...</option>
                        {this.props.chargeTypes &&
                          this.props.chargeTypes.map((chargeType, index) => (
                            <option key={index} value={chargeType.chargeId}>
                              {chargeType.chargeName} - ₹
                              {chargeType.chargePrice}
                            </option>
                          ))}
                      </select>
                    </div> */}

                    <button
                      type="submit"
                      className="btn btn-sm btn-primary col-sm-2"
                      style={{
                        marginBottom: "1.1rem",
                        marginTop: "2rem",
                        backgroundColor: "green",
                      }}
                      // onClick={this.handleSubmit}
                      // data-dismiss="modal"
                      disabled={this.props.loading}
                    >
                      {this.props.loading ? "Saving" : "Save"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <CategoriesTable chargeTypes={this.props.chargeTypes} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    // chargeTypes: state.charges.chargesTypes,
    loading: state.addCategory.loading,
    editCategoryNameLoading: state.addCategory.editCategoryNameLoading,
    categories: state.category.categories,
    
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    // onFetchChargesType: () => dispatch(actions.onFetchChargesType()),
    onAddCategory: (category, categories) =>
      dispatch(actions.onAddCategory(category, categories)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorHandler(AddCategories, Axios));
